import * as React from "react";
import Header from "@/components/template/dashboard-layout/header";
import Footer from "@/components/template/dashboard-layout/footer";
import { useParams, useSearchParams } from "react-router-dom";
import { backend } from "@/services/backend";
import { useEffect, useState } from "react";
import { OwnerData } from "@/types";
import { OwnerProvider, useOwner } from "@/context/OwnerContext";
import OwnerContainer from "./container";

export default function Owner() {
  const { address } = useParams();
  const [searchParams] = useSearchParams();
  const { isEditView, isOwnerView, trigger } = useOwner();
  const [ownerData, setOwnerData] = useState<OwnerData | null>(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchOwnerData = async () => {
      if (!address) return;
      const ownerData = await backend.getOwnerData(
        address,
        isEditView ? "owner" : "user"
      );
      setOwnerData(ownerData);
    };
    fetchOwnerData();
  }, [address, searchParams.get("view"), isEditView, trigger]); // Refetch when view changes

  return (
    <>
      <Header />
      <OwnerContainer ownerData={ownerData} />
      <Footer />
    </>
  );
}
